import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { take, switchMap } from 'rxjs';
import { map } from 'rxjs/operators';
import { AUTH_STATE } from '../tokens/auth-state.token';
import { GET_USER_STATUS } from '../tokens/user-status.token';
import { foreignRoleRedirect } from './role-areas';

/**
 * Protects /sales/** routes. Requires an authenticated user with role "ventas".
 * Anonymous → /. Other roles are redirected to their own area
 * (manager → /manager, socio → /home).
 */
export const salesGuard: CanActivateFn = () => {
  const authState$ = inject(AUTH_STATE);
  const getUserStatus = inject(GET_USER_STATUS);
  const router = inject(Router);

  return authState$.pipe(
    take(1),
    switchMap((user) => {
      if (!user) return [router.createUrlTree(['/'])];
      return getUserStatus(user.uid).pipe(
        map((status) => {
          if (!status) return router.createUrlTree(['/']);
          const away = foreignRoleRedirect(router, status.role, ['ventas']);
          if (away) return away;
          return true;
        }),
      );
    }),
  );
};
